// extracted by mini-css-extract-plugin
module.exports = {"statistics":"styles_statistics__3aslw","chart":"styles_chart__3AzZQ","item":"styles_item__1Gq76","bar":"styles_bar__2a7nE"};